import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, FormControl, Checkbox} from "react-bootstrap";
import Validator from "../../../../utilities/Validator";
import {TopButtonAction, TopButtonAdd, TopButtonCancel, TopButtonSave} from "../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../shared/validatorMessages/ValidatorMessages";
import {TopAlertOstrzezenie, TopAlertSukces, TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import FirmyService from "../FirmyService";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import Select from 'react-select'

export default class FirmyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nazwa: '',
            nip: '',
            regon: '',
            miejscowosc: '',
            kodPocztowy: '',
            ulica: '',
            budynek: '',
            lokal: '',
            wojewodztwo: '',
            powiat: '',
            gmina: '',
            poczta: '',
            formaPrawna: '',
            formaSzczegolowaNazwa: '',
            idFi: 0,
            idNabywcy: null,

            czyOdbiorca: false,
            firmaNabywca: null,
            istniejacyNabywca: null,

            validatorMessages: [],

            czyKliknietoWyszukaj: false,
            czyZnaleziono: false
        };
        this.onClickZapisz = this.onClickZapisz.bind(this);
        this.onChangeWartoscAndValidate = this.onChangeWartoscAndValidate.bind(this);
        this.onClickWyszukaj = this.onClickWyszukaj.bind(this);
        this.onChangeFirmaNabywca = this.onChangeFirmaNabywca.bind(this)
        this.ustawDoEdycji = this.ustawDoEdycji.bind(this)
    }

    componentDidMount() {

        console.log(this.props)

        if (!this.props.czyMoznaEdytowacNip) {
            this.ustawNip(this.props.nipFirmy)
        }
        this.ustawDoEdycji(this.props.edytowanaFirma)
    }

    componentWillUnmount() {
        this.setState({
            nazwa: '',
            nip: '',
            regon: '',
            miejscowosc: '',
            kodPocztowy: '',
            ulica: '',
            budynek: '',
            lokal: '',
            wojewodztwo: '',
            powiat: '',
            gmina: '',
            poczta: '',
            formaPrawna: '',
            formaSzczegolowaNazwa: '',
            idFi: 0,
            idNabywcy: null,

            czyOdbiorca: false,
            firmaNabywca: null,
            istniejacyNabywca: null,

            validatorMessages: [],

            czyKliknietoWyszukaj: false,
            czyZnaleziono: false
        })
    }

    componentWillReceiveProps(nextprops) {
        if (!nextprops.czyMoznaEdytowacNip) {
            this.ustawNip(nextprops.nipFirmy)
        }

        this.ustawDoEdycji(nextprops.edytowanaFirma)
    }

    ustawNip(nip) {
        if (nip !== null || nip !== '') {
            document.getElementById('inputNip').value = nip
            document.getElementById('inputNip').disabled = true;
            this.setState({
                nip: nip
            })
        }
    }

    ustawDoEdycji(firma, czyWyszukanoNip = false) {

        if (Boolean(firma)) {
            this.setState({
                nazwa: Boolean(firma.nazwa) ? firma.nazwa : '',
                regon: Boolean(firma.regon) ? firma.regon : '',
                miejscowosc: Boolean(firma.miejscowosc) ? firma.miejscowosc : '',
                kodPocztowy: Boolean(firma.kodPocztowy) ? firma.kodPocztowy : '',
                ulica: Boolean(firma.ulica) ? firma.ulica : '',
                budynek: (czyWyszukanoNip) ? firma.numerNieruchomosci : Boolean(firma.nrNieruchomosci) ? firma.nrNieruchomosci : '',
                lokal: (czyWyszukanoNip) ? firma.numerLokalu : Boolean(firma.nrLokalu) ? firma.nrLokalu : '',
                wojewodztwo: Boolean(firma.wojewodztwo) ? firma.wojewodztwo : '',
                powiat: Boolean(firma.powiat) ? firma.powiat : '',
                gmina: Boolean(firma.gmina) ? firma.gmina : '',
                poczta: Boolean(firma.poczta) ? firma.poczta : '',
                formaPrawna: (czyWyszukanoNip) ? firma.formaPodstawowaNazwa : Boolean(firma.formaPrawna) ? firma.formaPrawna : '',
                formaSzczegolowaNazwa: Boolean(firma.formaSzczegolowaNazwa) ? firma.formaSzczegolowaNazwa : '',
                idFi: (this.props.edytowanaFirma && !czyWyszukanoNip) ? firma.idFi : 0


            })

            if (!czyWyszukanoNip) {
                document.getElementById('inputNip').value = firma.nip
                this.setState({
                    nip: firma.nip
                })
            }

            document.getElementById('inputNazwa').value = firma.nazwa
            document.getElementById('inputRegon').value = firma.regon
            document.getElementById('inputMiejscowosc').value = firma.miejscowosc
            document.getElementById('inputKodPocztowy').value = firma.kodPocztowy
            document.getElementById('inputUlica').value = firma.ulica
            document.getElementById('inputNrNieruchomosci').value = (czyWyszukanoNip) ? firma.numerNieruchomosci : firma.nrNieruchomosci
            document.getElementById('inputNrLokalu').value = (czyWyszukanoNip) ? firma.numerLokalu : firma.nrLokalu
            document.getElementById('inputWojewodztwo').value = firma.wojewodztwo
            document.getElementById('inputPowiat').value = firma.powiat
            document.getElementById('inputGmina').value = firma.gmina
            document.getElementById('inputPoczta').value = firma.poczta
            document.getElementById('inputformaPrawna').value = (czyWyszukanoNip) ? firma.formaPodstawowaNazwa : firma.formaPrawna
            document.getElementById('inputformaSzczegolowaNazwa').value = firma.formaSzczegolowaNazwa


            if (firma.idNabywcy) {
                FirmyService.getFirma(firma.idNabywcy).then(function (response) {
                    console.log(response)
                    if (response.status < 300) {
                        if (response.data) {
                            this.setState({istniejacyNabywca: response.data})
                        }
                    }
                }.bind(this))
            }
        }
    }

    onChangeWartoscAndValidate(e, wartosc, max, elem) {
        if (Validator.validateLenghtWithClearing(e.target.value, max, elem, this.state[wartosc])) {

            this.setState({[wartosc]: e.target.value})

            if (wartosc === 'nip') {
                this.setState({
                    czyKliknietoWyszukaj: false,
                    czyZnaleziono: false
                })
            }
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {

        let poprawne = true;
        this.state.validatorMessages = [];

        if (!Boolean(this.state.nazwa)) {
            poprawne = false
            this.dodajDoValidatorMessages('Należy uzupełnic nazwę firmy')
        }
        /*if (!Boolean(this.state.nip)) {
            poprawne = false
            this.dodajDoValidatorMessages('Należy uzupełnic NIP firmy')
        }*/
        if (!Boolean(this.state.miejscowosc)) {
            poprawne = false
            this.dodajDoValidatorMessages('Należy uzupełnic miejscowość')
        }

        if (this.state.czyOdbiorca && !this.state.firmaNabywca) {
            poprawne = false
            this.dodajDoValidatorMessages('Należy uzupełnic nabywcę')
        }

        if (!this.state.czyOdbiorca && !Boolean(this.state.nip)) {
            poprawne = false
            this.dodajDoValidatorMessages('Firma musi zawierać NIP jeśli nie jest odbiorcą!')
        }

        if (poprawne) {

            let data = {
                "formaPrawna": this.state.formaPrawna,
                "formaSzczegolowaNazwa": this.state.formaSzczegolowaNazwa,
                "gmina": this.state.gmina,
                "idFi": this.state.idFi,
                "kodPocztowy": this.state.kodPocztowy,
                "miejscowosc": this.state.miejscowosc,
                "nazwa": this.state.nazwa,
                "nip": this.state.nip,
                "nrLokalu": this.state.lokal,
                "nrNieruchomosci": this.state.budynek,
                "poczta": this.state.poczta,
                "powiat": this.state.powiat,
                "regon": this.state.regon,
                "ulica": this.state.ulica,
                "wojewodztwo": this.state.wojewodztwo,
                "idNabywcy": Boolean(this.state.istniejacyNabywca) ? this.state.istniejacyNabywca.idFi : Boolean(this.state.firmaNabywca) ? this.state.firmaNabywca.idFi : null,
            }

            this.props.handleClickZapisz(data, Boolean(this.props.edytowanaFirma))

        }
    }

    onClickWyszukaj() {
        this.setState({
            czyKliknietoWyszukaj: true,
        })
        if (this.state.nip.length >= 10) {
            let czyZnaleziono = false
            FirmyService.szukajFirmePoNipie(this.state.nip).then(function (response) {
                if (response) {
                    if (response.data) {
                        czyZnaleziono = true
                        this.ustawDoEdycji(response.data, true)
                    }
                }

                this.setState({czyZnaleziono: czyZnaleziono})
            }.bind(this))
        }
    }

    getCompanies(input) {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return FirmyService.szukajFirmePoNipieAlboPoNazwie(input).then(function (response) {

            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    informacje: item.nip + ' ' + item.nazwa,
                }
            })
            return {options: arr}
        }.bind(this))
    }

    onChangeFirmaNabywca(e) {
        if (e !== null) {
            if (e.nip) {
                this.setState({firmaNabywca: e, istniejacyNabywca: null})
            } else {
                alert('Wybrana firma musi posiadać NIP!')
            }
        } else {
            this.setState({firmaNabywca: null, istniejacyNabywca: null})
        }
    }

    renderFirmaOption(option) {
        return (<div><span className={'label label-ebus-primary'} title={'NIP'}>{option.nip}</span> {option.nazwa}
            {option.idNabywcy ?
                <span style={{color: 'grey', fontSize: '12px', marginLeft: '15px'}}><i
                    className={'fa fa-info-circle'}></i> Tylko odbiorca!</span> : ''}
        </div>)
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.edytowanaFirma) ? 'Edycja firmy' : 'Nowa firma'}</div>
                    <Form horizontal={true}>
                        <FormGroup style={{marginBottom: 0}}>
                            <Col xs={12}>
                                {
                                    Boolean(this.state.czyKliknietoWyszukaj) ?
                                        Boolean(this.state.czyZnaleziono) ?
                                            <TopAlertSukces text={'Znaleziono firmę po numerze NIP i uzupełniono dane'}/>
                                            :
                                            Boolean(this.state.nip.length < 10) ?
                                                <TopAlertUwaga text={'Podano nieprawidłowy numer NIP! Musi posiadać co najmniej 10 znaków'}/>
                                                :
                                                <TopAlertOstrzezenie text={'Nie znaleziono firmy po numerze NIP'}/>
                                        :
                                        ''
                                }
                            </Col>
                            <Col lg={(this.props.widokNaPopup) ? 5 : 3}>
                                <ControlLabel>
                                    NIP {/*<span className={'req'}>*</span>*/} <span
                                    style={{fontSize: '12px', color: 'grey', fontStyle: 'italic', fontWeight: 'normal'}}>
                                    {this.state.nip ? this.state.nip.length : '?'}
                                    /20 znaków</span>
                                </ControlLabel>
                                <Row>
                                    <Col xs={8}>
                                        <FormControl id={'inputNip'} onChange={(e) => this.onChangeWartoscAndValidate(e, 'nip', 20, 'inputNip')}/>
                                    </Col>
                                    <Col xs={4}>
                                        <TopButtonAction iconType={'fa fa-search'} text={'Wyszukaj'} btnSize={'md'} onClick={this.onClickWyszukaj}/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={(this.props.widokNaPopup) ? 5 : 4}>
                                <ControlLabel>
                                    Nazwa <span className={'req'}>*</span> <span
                                    style={{fontSize: '12px', color: 'grey', fontStyle: 'italic', fontWeight: 'normal'}}>{this.state.nazwa.length}/200 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputNazwa'} onChange={(e) => this.onChangeWartoscAndValidate(e, 'nazwa', 200, 'inputNazwa')}/>
                            </Col>
                            <Col lg={2}>
                                <ControlLabel>
                                    REGON <span
                                    style={{fontSize: '12px', color: 'grey', fontStyle: 'italic', fontWeight: 'normal'}}>{this.state.regon.length}/14 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputRegon'} type={'number'}
                                             onChange={(e) => this.onChangeWartoscAndValidate(e, 'regon', 14, 'inputRegon')}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col lg={3}>
                                <ControlLabel>
                                    Forma prawna <span style={{
                                    fontSize: '12px',
                                    color: 'grey',
                                    fontStyle: 'italic',
                                    fontWeight: 'normal'
                                }}>{this.state.formaPrawna.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputformaPrawna'}
                                             onChange={(e) => this.onChangeWartoscAndValidate(e, 'formaPrawna', 100, 'inputformaPrawna')}/>
                            </Col>
                            <Col lg={4}>
                                <ControlLabel>
                                    Forma szczegółowa nazwa <span style={{
                                    fontSize: '12px',
                                    color: 'grey',
                                    fontStyle: 'italic',
                                    fontWeight: 'normal'
                                }}>{this.state.formaSzczegolowaNazwa.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputformaSzczegolowaNazwa'}
                                             onChange={(e) => this.onChangeWartoscAndValidate(e, 'formaSzczegolowaNazwa', 100, 'inputformaSzczegolowaNazwa')}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col lg={3}>
                                <ControlLabel>
                                    Miejscowość <span className={'req'}>*</span> <span style={{
                                    fontSize: '12px',
                                    color: 'grey',
                                    fontStyle: 'italic',
                                    fontWeight: 'normal'
                                }}>{this.state.miejscowosc.length}/200 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputMiejscowosc'}
                                             onChange={(e) => this.onChangeWartoscAndValidate(e, 'miejscowosc', 200, 'inputMiejscowosc')}/>
                            </Col>
                            <Col lg={(this.props.widokNaPopup) ? 3 : 2}>
                                <ControlLabel>
                                    Ulica <span
                                    style={{fontSize: '12px', color: 'grey', fontStyle: 'italic', fontWeight: 'normal'}}>{this.state.ulica.length}/200 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputUlica'} onChange={(e) => this.onChangeWartoscAndValidate(e, 'ulica', 200, 'inputUlica')}/>
                            </Col>
                            <Col lg={(this.props.widokNaPopup) ? 3 : 2}>
                                <ControlLabel>
                                    Budynek / lokal
                                </ControlLabel>
                                <Row>
                                    <Col xs={6}>
                                        <FormControl id={'inputNrNieruchomosci'}
                                                     onChange={(e) => this.onChangeWartoscAndValidate(e, 'budynek', 20, 'inputNrNieruchomosci')}/>
                                    </Col>
                                    <Col xs={6}>
                                        <FormControl id={'inputNrLokalu'}
                                                     onChange={(e) => this.onChangeWartoscAndValidate(e, 'lokal', 20, 'inputNrLokalu')}/>
                                    </Col>
                                </Row>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col lg={2}>
                                <ControlLabel>
                                    Kod pocztowy <span style={{
                                    fontSize: '12px',
                                    color: 'grey',
                                    fontStyle: 'italic',
                                    fontWeight: 'normal'
                                }}>{this.state.kodPocztowy.length}/10 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputKodPocztowy'}
                                             onChange={(e) => this.onChangeWartoscAndValidate(e, 'kodPocztowy', 10, 'inputKodPocztowy')}/>
                            </Col>
                            <Col lg={5}>
                                <ControlLabel>
                                    Poczta <span
                                    style={{fontSize: '12px', color: 'grey', fontStyle: 'italic', fontWeight: 'normal'}}>{this.state.poczta.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputPoczta'} onChange={(e) => this.onChangeWartoscAndValidate(e, 'poczta', 100, 'inputPoczta')}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col lg={2}>
                                <ControlLabel>
                                    Wojewodztwo <span style={{
                                    fontSize: '12px',
                                    color: 'grey',
                                    fontStyle: 'italic',
                                    fontWeight: 'normal'
                                }}>{this.state.wojewodztwo.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputWojewodztwo'}
                                             onChange={(e) => this.onChangeWartoscAndValidate(e, 'wojewodztwo', 100, 'inputWojewodztwo')}/>
                            </Col>
                            <Col lg={3}>
                                <ControlLabel>
                                    Powiat <span
                                    style={{fontSize: '12px', color: 'grey', fontStyle: 'italic', fontWeight: 'normal'}}>{this.state.powiat.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputPowiat'} onChange={(e) => this.onChangeWartoscAndValidate(e, 'powiat', 100, 'inputPowiat')}/>
                            </Col>
                            <Col lg={2}>
                                <ControlLabel>
                                    Gmina <span
                                    style={{fontSize: '12px', color: 'grey', fontStyle: 'italic', fontWeight: 'normal'}}>{this.state.gmina.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl id={'inputGmina'} onChange={(e) => this.onChangeWartoscAndValidate(e, 'gmina', 100, 'inputGmina')}/>
                            </Col>
                            <TopIf isTrue={!this.state.czyOdbiorca}>
                                <Col lg={3}>
                                    <div className={'add-label-margin'}></div>
                                    {
                                        !Boolean(this.props.usunButtonAnuluj) &&
                                        <TopButtonCancel onClick={() => {
                                            this.props.handleClickAnuluj()
                                        }} text={'Anuluj'}/>
                                    }
                                    <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                                </Col>
                            </TopIf>
                        </FormGroup>
                        <FormGroup>
                            {
                                Boolean(this.state.istniejacyNabywca) ?
                                    <Col xs={12}>
                                        <h5>Zapisany nabywca: <span style={{color: 'grey', cursor: 'pointer'}} onClick={() => {
                                            this.setState({czyOdbiorca: true, istniejacyNabywca: null})
                                        }}><i className={'fa fa-edit'}></i>Zmień</span></h5>
                                        <div>
                                            <span
                                                className={'label label-ebus-default'}>{this.state.istniejacyNabywca.nip}</span> {this.state.istniejacyNabywca.nazwa}
                                        </div>
                                    </Col> : ''
                            }
                            <Col lg={2}>
                                <TopIf isTrue={this.state.czyOdbiorca}>
                                    <div className={'add-label-margin'}></div>
                                </TopIf>
                                {
                                    Boolean(!this.state.istniejacyNabywca) ?
                                        <Checkbox checked={this.state.czyOdbiorca} onClick={() => {
                                            this.setState({czyOdbiorca: this.state.czyOdbiorca ? false : true})
                                        }}>Dodawana intytucja jest odbiorcą</Checkbox>
                                        :
                                        ''
                                }
                            </Col>
                            <TopIf isTrue={this.state.czyOdbiorca}>
                                <Col lg={5}>
                                    <ControlLabel>Wyszukaj nabywcę po NIP lub nazwie<span className={'req'}>*</span></ControlLabel>
                                    <Select.Async value={this.state.firmaNabywca}
                                                  onChange={this.onChangeFirmaNabywca}
                                                  valueKey="idFi"
                                                  labelKey="informacje" loadOptions={this.getCompanies}
                                                  clearable={false}
                                                  backspaceRemoves={true}
                                                  placeholder={'Wyszukaj firmę po NIP lub po nazwie'}

                                                  valueRenderer={(option) => this.renderFirmaOption(option)}
                                                  optionRenderer={(option) => this.renderFirmaOption(option)}
                                                  ignoreAccents={false}
                                                  noResultsText={<div>Brak wyników - proszę dodać firmę</div>}
                                    />
                                </Col>
                            </TopIf>
                            <TopIf isTrue={this.state.czyOdbiorca}>
                                <Col lg={3}>
                                    <div className={'add-label-margin'}></div>
                                    {
                                        !Boolean(this.props.usunButtonAnuluj) &&
                                        <TopButtonCancel onClick={() => {
                                            this.props.handleClickAnuluj()
                                        }} text={'Anuluj'}/>
                                    }
                                    <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                                </Col>
                            </TopIf>
                        </FormGroup>
                        <FormGroup>
                            <ValidatorMessages messages={this.state.validatorMessages}/>
                        </FormGroup>
                    </Form>
                </fieldset>

                <div style={{clear: 'both'}}></div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/firmy/components/FirmyForm.js